import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import MainContent from 'modules/surveys/pages/QuestionsTemplates/MainContent'
import TemplateDeleteModal from 'modules/surveys/pages/QuestionsTemplates/TemplateDeleteModal'
import questionsTemplates from 'modules/surveys/store/collections/questionsTemplates'
import type QuestionsTemplate from 'modules/surveys/store/models/QuestionsTemplate'

interface ContentProps {
  questionsTemplate: QuestionsTemplate | null | undefined
}

const Content = ({ questionsTemplate }: ContentProps) => {
  if (!questionsTemplate) return null

  return <MainContent questionsTemplate={questionsTemplate} />
}

interface UseFetchDataType {
  loading: boolean
  questionsTemplate: QuestionsTemplate | null | undefined
}

function useFetchData(questionsTemplateId: string | undefined): UseFetchDataType {
  const { loading } = useAsyncData(() => questionsTemplates.fetch(), [])
  if (!questionsTemplateId)
    return {
      loading: false,
      questionsTemplate: undefined,
    }

  const attr = {
    id: questionsTemplateId,
  }

  const questionsTemplate = !loading ? questionsTemplates.find(attr) : null

  return {
    loading,
    questionsTemplate,
  }
}

function SurveyQuestionsTemplateSettings() {
  const { questionsTemplateId } = useParams()
  const { loading, questionsTemplate } = useFetchData(String(questionsTemplateId))
  const [deleteTemplateModal, setDeleteTemplateModal] = useState(false)
  const onClose = () => setDeleteTemplateModal(false)

  const { navigation } = useNavigation()

  return (
    <ResponsivePage.Body
      loading={loading}
      variant="wide"
      error={null}
      showHeader
      widget={
        questionsTemplate &&
        (!questionsTemplate.isDefault || !questionsTemplate.isCore) && (
          <Button onClick={() => setDeleteTemplateModal(true)}>
            {i18n.t('app_store_v2.apps.performance_v2.settings.templates.delete.submit')}
          </Button>
        )
      }
    >
      <Content questionsTemplate={questionsTemplate} />
      {deleteTemplateModal && questionsTemplate && (
        <TemplateDeleteModal
          onClose={onClose}
          onCancel={onClose}
          navigatePathOnDeleted={navigation.settings.surveys.fullPath()}
          questionsTemplateId={questionsTemplate.attributes.id}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default observer(SurveyQuestionsTemplateSettings)
